import { useContext } from 'react';
import InstancesContext from 'src/contexts/InstancesContext';

const useInstancesContext = () => {
  const context = useContext(InstancesContext);
  if (!context) {
    throw new Error('useInstancesContext must be used within a InstancesProvider');
  }
  return context;
};

export default useInstancesContext;
